var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopdots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.107,
    height: 14.203,
    viewBox: "0 0 3.107 14.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18240",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18240",
    transform: "translate(3.107 14.203) rotate(180)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_5214",
    "data-name": "\\u6955\\u5186\\u5F62 5214",
    cx: 1.553,
    cy: 1.597,
    rx: 1.553,
    ry: 1.597,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_5215",
    "data-name": "\\u6955\\u5186\\u5F62 5215",
    cx: 1.553,
    cy: 1.597,
    rx: 1.553,
    ry: 1.597,
    transform: "translate(0 5.504)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_5216",
    "data-name": "\\u6955\\u5186\\u5F62 5216",
    cx: 1.553,
    cy: 1.597,
    rx: 1.553,
    ry: 1.597,
    transform: "translate(0 11.008)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopdots);
export default __webpack_public_path__ + "static/media/topdots.ec75835dd756539f7e48fe9360298d5e.svg";
export { ForwardRef as ReactComponent };